import React, { useState, useEffect, useRef } from 'react';
import { MenuItem, TextField } from '@mui/material';

type SelectProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { key: string; label: string }[];
  disabled?: boolean;
};

export default function Select({ label, value, options, onChange, disabled }: SelectProps) {
  return (
    <TextField
      select
      fullWidth
      required
      label={label}
      variant="outlined"
      size="medium"
      style={{ height: 46, boxSizing: 'content-box' }}
      sx={{
        height: '46px',
        '& .MuiInputBase-root': {
          height: '46px',
        },
        '& .MuiSelect-select': {
          height: '46px',
        },
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    >
      {options.map((option) => (
        <MenuItem key={option.key} value={option.key}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
